import Dropdown from 'react-bootstrap/Dropdown';

const MenuLateral = () => {
    return <>
        <div className="menu-lateral">
            <div>
                <Dropdown >
                    <Dropdown.Toggle className="w-100 text-center drop-titulo" id="dropdown-basic">
                        Atribuições de milhas
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="dropdown-menu dropend">
                        <Dropdown.Item className="text-light link-dropdown" href="/AtribuicaoMilhas">Atribuir Milhas</Dropdown.Item>
                        <Dropdown.Item className="text-light link-dropdown" href="/AtribuicaoMilhasEventos">Atribuir Milhas de Evento</Dropdown.Item>
                        <Dropdown.Item className="text-light link-dropdown" href="/AtribuicaoExterna">Atribuição de Produção</Dropdown.Item>
                        <Dropdown.Item className="text-light link-dropdown" href="/AtribuicaoDinamica">Atribuição Dinâmica</Dropdown.Item>
                        <Dropdown.Item className="text-light link-dropdown" href="/Atribuicoes">Lista de Atribuições</Dropdown.Item>
                        <Dropdown.Item className="text-light link-dropdown" href="/AtribuicoesExternas">Lista de Atrib. Produção</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
            <div>
                <Dropdown >
                    <Dropdown.Toggle className="w-100 text-center drop-titulo" id="dropdown-basic">
                        Colaboradores
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        <Dropdown.Item className="text-light link-dropdown" href="/CadastroColaborador">Cadastrar Colaborador</Dropdown.Item>
                        <Dropdown.Item className="text-light link-dropdown" href="/Colaboradores">Lista de Colaboradores</Dropdown.Item>
                        <Dropdown.Item className="text-light link-dropdown" href="/Pontuacoes">Saldo Milhas Colaboradores</Dropdown.Item>
                        <Dropdown.Item className="text-light link-dropdown" href="/PontuacoesExterna">Saldo Milhas Prod. Colab.</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
            <div>
                <Dropdown>
                    <Dropdown.Toggle className="w-100 text-center drop-titulo" id="dropdown-basic">
                        Cargos
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        <Dropdown.Item className="text-light link-dropdown" href="/CadastroCargo">Cadastrar Cargo</Dropdown.Item>
                        <Dropdown.Item className="text-light link-dropdown" href="/cargos">Lista de Cargos</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
            <div>
                <Dropdown>
                    <Dropdown.Toggle className="w-100 text-center drop-titulo" id="dropdown-basic">
                        Motivos
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        <Dropdown.Item className="text-light link-dropdown" href="/CadastroMotivo">Cadastrar Motivo</Dropdown.Item>
                        <Dropdown.Item className="text-light link-dropdown" href="/Motivos">Lista de Motivos</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
            <div>
                <Dropdown>
                    <Dropdown.Toggle className="w-100 text-center drop-titulo" id="dropdown-basic">
                        Produtos
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        <Dropdown.Item className="text-light link-dropdown" href="/CadastroProduto">Cadastrar Produto</Dropdown.Item>
                        <Dropdown.Item className="text-light link-dropdown" href="/Produtos">Lista de Produtos</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
            <div>
                <Dropdown >
                    <Dropdown.Toggle className="w-100 text-center drop-titulo" id="dropdown-basic">
                        Solicitações
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        <Dropdown.Item className="text-light link-dropdown" href="/SolicitacoesPendentes">Solicitações Pendentes</Dropdown.Item>
                        <Dropdown.Item className="text-light link-dropdown" href="/Solicitacoes">Todas as Solicitações</Dropdown.Item>
                        <Dropdown.Item className="text-light link-dropdown" href="/SolicitacoesExternasPendentes">Sol. Prod. Pendentes</Dropdown.Item>
                        <Dropdown.Item className="text-light link-dropdown" href="/ListaSolicitacoesExternas">Todas as Sol. Prod.</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
            <div>
                <Dropdown >
                    <Dropdown.Toggle className="w-100 text-center drop-titulo" id="dropdown-basic">
                        Setores
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        <Dropdown.Item className="text-light link-dropdown" href="/CadastroSetor">Cadastrar Setor</Dropdown.Item>
                        <Dropdown.Item className="text-light link-dropdown" href="/Setores">Lista de Setores</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        </div>

    </>
}

export default MenuLateral;